import Axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/oidc'

Axios.defaults.timeout = 5000 * 8

Axios.interceptors.request.use(async config => {
  config.baseURL = config.baseURL || window.domainConfig.gatewayServer
  let token = await getToken().catch(() => {})
  if (token) {
    config.headers.Authorization = token
  }
  const orgId = store.getState().orgId
  if (orgId) {
    config.headers['x-currentorgid'] = orgId
  }
  return config
})

Axios.interceptors.response.use(async response => {
  const { config, data } = response
  // 处理blob类型响应
  if (config.responseType === 'blob') {
    if (data && data instanceof Blob) {
      try {
        const res = JSON.parse(await data.text())
        return Promise.reject(res)
      } catch (error) {
        return response
      }
    }
    return response
  }

  // 如果请求配置中指定了all，或者响应数据是简单对象（不包含isSuccess等字段），直接返回数据
  if (response.config.all || (typeof data === 'object' && !('isSuccess' in data) && !('businessCode' in data))) {
    return data
  } else if (data.isSuccess === true || (data.isSuccess === 'true' && data.businessCode === 0)) {
    return data.returnObj
  }

  const errorObj = {
    message: data.businessMessage || data.sysMessage,
    code: data.businessCode
  }
  return Promise.reject(errorObj)
})

class Http {
  formData(url, params, config = {}) {
    let preparedData = null
    if (params instanceof window.FormData) {
      preparedData = params
    } else {
      preparedData = new window.FormData()
      for (const key of Object.keys(params)) {
        preparedData.append(key, params[key])
      }
    }
    return Axios.post(url, preparedData, config)
  }
  get(url, params, config = {}) {
    return Axios.get(url, { params: params, ...config })
  }
  post(url, params, config = {}) {
    return Axios.post(url, params, config)
  }
}

export default new Http()
